import { CardActions } from "@material-ui/core";

export default CardActions;
